import React from "react";
import { Navigate } from "react-router-dom";
import { initialUrl } from "shared/constants/AppConst";
import { authRouteConfig } from "./auth";
import Error403 from "./errorPages/Error403";
import { errorPagesConfigs } from "./errorPages";
import { DashBoardConfigs } from "./dashboards";
import { IssuesConfigs } from "./issues";
import { LeaveConfigs } from "./leave";
import { RoomBookingConfig } from "./roomBooking";
import { AccountPagesConfigs } from "./account";
import { CRMConfig } from "./crm";
import { NewsUpdateConfigs } from "./newsAndUpdated";
import { EventConfigs } from "./events";
import { AttendanceConfigs } from "./attendence";
import { PerformanceManagementConfigs } from "./Performance";
import { ProjectConfigs } from "./Performance/project";
import { GoalConfigs } from "./Performance/goal";
import { FeedBackConfigs, feedBackConfigPublic } from "./feedback";
import { MasterConfig } from "./master";
import { SosConfigs, sosPublicRouteConfig } from "./sos";
import { ReportConfigs } from "./reports";

const authorizedStructure = {
    fallbackPath: "/signin",
    unAuthorizedComponent: <Error403 />,
    routes: [
        ...DashBoardConfigs,
        ...IssuesConfigs,
        ...PerformanceManagementConfigs,
        ...LeaveConfigs,
        ...RoomBookingConfig,
        ...CRMConfig,
        ...EventConfigs,
        ...AttendanceConfigs,
        ...AccountPagesConfigs,
        ...ProjectConfigs,
        ...GoalConfigs,
        ...NewsUpdateConfigs,
        ...FeedBackConfigs,
        ...MasterConfig,
        ...SosConfigs,
        ...ReportConfigs
    ],
};

const unAuthorizedStructure = {
    fallbackPath: initialUrl,
    routes: [...authRouteConfig, ...feedBackConfigPublic, ...sosPublicRouteConfig],
};
const anonymousStructure = {
    routes: errorPagesConfigs.concat([
        {
            path: "/",
            element: <Navigate to={initialUrl} />,
        },
        {
            path: "*",
            element: <Navigate to="/error-pages/error-404" />,
        },
    ]),
};

export { authorizedStructure, unAuthorizedStructure, anonymousStructure };
